
var Intesa = Intesa || {};

Intesa.videoPlayerHandler = function () {

	var videoPlayer = this;
	var isRtl = $('html').attr('dir') === "rtl";

    this.prev;
    this.next;
    this.track;
    this.carouselWidth;
    this.cardWidth;
    this.card;
    this.style;
    this.margin;
    this.padding;
    this.border;
    this.minTrack = 15,
    this.currentCard = 15; // this is the zero of the carousel
	this.currentCards;
    this.totalCardWidth;
	this.iframe = $('#iframe__video');
	this.iframeVideo = $('video#iframe__video');
	this.numberOfCardsToDisplay = 4;

    this.init = function () {

        if (!document.querySelector(".video__player__wrapper")) {
            console.log('not init')
            return;
        }

        console.log('init')

		if(isMultiple()){
			this.currentCards = new Array($('.newVideoPlayerComponent').length);
			for(var i = 0; i < $('.newVideoPlayerComponent').length; i++){
				$('.newVideoPlayerComponent')[i].classList.add('n'+i);
				this.currentCards[i] = 0;
			}
		}

        try {
			
        	videoPlayer.prev = document.querySelector(".prev");
        	videoPlayer.next = document.querySelector(".next");
        	videoPlayer.track = document.querySelector(".track");
        	videoPlayer.carouselWidth = document.querySelector(".carousel-container").offsetWidth;
        	videoPlayer.cardWidth = document.querySelector(".card-container").offsetWidth;
        	

        	videoPlayer.card = document.querySelector('.card-container'),
        	videoPlayer.width = videoPlayer.card.offsetWidth,
        	videoPlayer.style = videoPlayer.card.currentStyle || window.getComputedStyle(videoPlayer.card),
        	videoPlayer.margin = parseFloat(videoPlayer.style.marginLeft) + parseFloat(videoPlayer.style.marginRight),
        	videoPlayer.padding = parseFloat(videoPlayer.style.paddingLeft) + parseFloat(videoPlayer.style.paddingRight),
        	videoPlayer.border = parseFloat(videoPlayer.style.borderLeftWidth) + parseFloat(videoPlayer.style.borderRightWidth),
        	videoPlayer.cardWidth = videoPlayer.width + videoPlayer.margin + videoPlayer.padding + videoPlayer.border,
        	
        	
        	console.log("video player card width :",videoPlayer.cardWidth);
        	
        	console.log("total card width :",-Math.abs(videoPlayer.cardWidth * (document.querySelectorAll('.card-container').length)));
        	
        	videoPlayer.totalCardWidth = -Math.abs(videoPlayer.cardWidth * (document.querySelectorAll('.card-container').length));

    		if(document.documentElement.clientWidth > 768){
    			videoPlayer.track.style.transform = "translateX(0)";
    			videoPlayer.minTrack = 0;
    			videoPlayer.currentCard = 0;
    		}else{
    			videoPlayer.track.style.transform = "translateX(0)";
    			videoPlayer.minTrack = 0;
    			videoPlayer.currentCard = 0;
    			this.numberOfCardsToDisplay = 2;
    		}
    		
    		videoPlayer.buttonsCheck();
    		
    		videoPlayer.createThumbYoutubeIframe();
    		
    		videoPlayer.createThumbYoutubeCards();
    		
        } catch (e) {
            console.log(e);
            console.log('no video to handle');
        }

        videoPlayer.initEvents();       

        
    }
	
	this.findPos = function(){}

    this.createThumbYoutubeCards = function(){
    	$(".card").each(function(){
    		var thumb;
    		var attrType  = $(this).attr("js-type-link");
    		var attrHasThumb = $(this).attr("js-has-thumb");
    		if(attrType == "external" && attrHasThumb == "false"){
    			var videoLink = $(this).find("img").attr("js-data-video");
    			var videoId = videoLink.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();
    			console.log("videoId",videoId);
    			if(videoId.length == 11){
    				thumb = "//img.youtube.com/vi/"+videoId+"/0.jpg"
    				$(this).find("img").attr("src", thumb);
    			}
    		}
    	});
    }
    
    this.createThumbYoutubeIframe = function (){
    	var linkType = $("#poster").attr("js-link-type");
    	var hasThumb =  $("#poster").attr("js-has-thumb");
    	var thumb;
    	if (linkType == "external" && hasThumb == "false"){
    		var videoLink = $("#iframe__video").attr("src");
    		var videoId = videoLink.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();
    		console.log("videoId iframe:",videoId);
			if(videoId.length == 11){
				thumb = "//img.youtube.com/vi/"+videoId+"/0.jpg"
				$("#poster").attr("src", thumb);
			}
    	}
    }
    
	this.addVideoToCards = function(url, title, description, element){
		console.log("url passed:",url);
		var img = $("#poster").attr("src");
		var imgCard = element.find("img").attr("src");
		if(imgCard == "" || imgCard == null || imgCard == undefined ){
			$("#poster").attr("src"," ");
		}else{
			$("#poster").attr("src",imgCard );
		}
		element.attr("js-description-card", description);
		element.find("img").attr("src",img);
		element.find("img").attr("js-data-video",url);
		element.attr("js-description-card", description);
		element.find('.card-description')[0].innerText = title;
		videoPlayer.buttonsCheck();
	}

	this.hidePoster = function(pos){
		if(pos == null || pos == undefined) pos = 0;

		var videoIcon = document.querySelectorAll('.video-icon')[pos]
		var poster = document.querySelectorAll('#poster')[pos]
		if(videoIcon != undefined && videoIcon != null && poster != undefined && poster != null){
			videoIcon.style.display = 'none';
			poster.style.display = 'none';
		}
		$('[id="iframe__video"]').eq(pos).show();
	}

    this.buttonsCheck= function (currentCard) {

		var max = -Math.abs(videoPlayer.track.offsetWidth) - videoPlayer.cardWidth + (videoPlayer.cardWidth * videoPlayer.numberOfCardsToDisplay);
		
		if(currentCard == null){
			currentCard = videoPlayer.currentCard;
		}

		if(isRtl) currentCard = -currentCard;

		if (currentCard <= max) {
			videoPlayer.prev.style.display = "";
			videoPlayer.next.style.display = "none";
		}
		if (currentCard >= videoPlayer.minTrack) {
			videoPlayer.prev.style.display = "none";
			videoPlayer.next.style.display = "";
		}
		if (currentCard > max && currentCard < videoPlayer.minTrack) {
			videoPlayer.prev.style.display = "";
			videoPlayer.next.style.display = "";
		}
	}
    
	this.pip = function() {
		var elmnt = videoPlayer.iframe.contentWindow.document.getElementsByTagName("video")[0];
		elmnt.requestPictureInPicture();
	}

    this.initEvents = function () {
        
		$('.card').on('click', function () {
			var pos = 0;
			if(isMultiple()){
				pos = findPos($(this));
				videoPlayer.iframe = $('[id="iframe__video"]').eq(pos);
			}
			
			console.log(pos);
			var checkIframeAttribute = $('[id="iframe__video"]').eq(pos).attr("allow");
			if(!checkIframeAttribute.includes("autoplay")){
				$('[id="iframe__video"]').eq(pos).attr("allow", "picture-in-picture; accelerometer; clipboard-write; encrypted-media; gyroscope; autoplay;");
			}
			var card = $(this)
			var currentUrl = $('[id="iframe__video"]').eq(pos).attr('src');
			var title =  $('.video__title')[pos].innerText;
			var description = $(".video-description")[pos].innerText;
			console.log("current url:",currentUrl);
			var link = card.find('img').attr('js-data-video');
			videoPlayer.hidePoster(pos);
			if(link.includes('watch?v=')){
				link = link.replace('watch?v=', 'embed/')
			}
			if(!link.includes("autoplay")){
				var symbol = link.indexOf("?") > -1 ? "&" : "?";
				link += symbol + "autoplay=1";
			}
			//rimuovo spazi all'inizio della stringa e alla fine della stringa se presenti
			const regexStartSpace = /^%20/;
            const regexEndSpace = /%20$/;
			while (link.match(regexStartSpace) || link.match(regexEndSpace)) {
                if (link.match(regexStartSpace)) {
                    link = link.replace(regexStartSpace, "");
                }
                if (link.match(regexEndSpace)) {
                    link = link.replace(regexEndSpace, "");
                }
            }
			card.find("img").attr("js-data-video", link);

			videoPlayer.iframe.attr('src', link);
			$('.video__title')[pos].innerText = card.find('.card-description')[0].innerText; 
			$(".video-description")[pos].innerText = $(this).attr("js-description-card");
			if(currentUrl){
				videoPlayer.addVideoToCards(currentUrl, title, description , $(this));
			}
		});
		
		
		$('.next, .prev').on('click', function() {

			if(isMultiple()){

				var pos = findPos($(this))

				var cardWidthRecalc = document.getElementsByClassName('newVideoPlayerComponent n'+pos)[0].querySelectorAll('.card-container')[0].offsetWidth + parseFloat(videoPlayer.style.marginLeft) + parseFloat(videoPlayer.style.marginRight) + parseFloat(videoPlayer.style.paddingLeft) + parseFloat(videoPlayer.style.paddingRight) + parseFloat(videoPlayer.style.borderLeftWidth) + parseFloat(videoPlayer.style.borderRightWidth);
				totalCardWidth = -Math.abs(document.getElementsByClassName('newVideoPlayerComponent n'+pos)[0].querySelectorAll('.card-container')[0].offsetWidth * (document.getElementsByClassName('newVideoPlayerComponent n'+pos)[0].querySelectorAll('.card-container').length));
				
				videoPlayer.prev = document.querySelectorAll(".prev")[pos];
				videoPlayer.next = document.querySelectorAll(".next")[pos];

				videoPlayer.track = document.querySelectorAll('.track')[pos];
				videoPlayer.currentCard = videoPlayer.currentCards[pos];
					
				if(isRtl) cardWidthRecalc = -cardWidthRecalc;

				$(this).hasClass('next') ? videoPlayer.currentCard -= cardWidthRecalc : videoPlayer.currentCard += cardWidthRecalc;

				videoPlayer.currentCards[pos] = videoPlayer.currentCard;

			} else {

				var cardWidthRecalc = document.querySelector('.card-container').offsetWidth + parseFloat(videoPlayer.style.marginLeft) + parseFloat(videoPlayer.style.marginRight) + parseFloat(videoPlayer.style.paddingLeft) + parseFloat(videoPlayer.style.paddingRight) + parseFloat(videoPlayer.style.borderLeftWidth) + parseFloat(videoPlayer.style.borderRightWidth);
				totalCardWidth = -Math.abs(document.querySelector('.card-container').offsetWidth * (document.querySelectorAll('.card-container').length));
			
				if(isRtl) cardWidthRecalc = -cardWidthRecalc;

				$(this).hasClass('next') ? videoPlayer.currentCard -= cardWidthRecalc : videoPlayer.currentCard += cardWidthRecalc;

			}
			videoPlayer.track.style.transform = "translateX(" + videoPlayer.currentCard + "px)";
			videoPlayer.buttonsCheck();
		});
		
		$('#poster, .video-icon').on('click', function() {
			console.log("clicked");
			var pos = 0;
			if(isMultiple()){
				pos = findPos($(this));
				videoPlayer.iframe = $('[id="iframe__video"]').eq(pos);
			}
			videoPlayer.hidePoster(pos);
				if(videoPlayer.iframe.attr('js-video-link') != '' && videoPlayer.iframe.attr('js-video-link') != undefined) {
					var url = videoPlayer.iframe.attr('js-video-link');
					if(!url.includes("autoplay")){
						var symbol = url.indexOf("?") > -1 ? "&" : "?";
						url += symbol + "autoplay=1";
					}
					$('[id="iframe__video"]').eq(pos).attr("allow", "picture-in-picture; accelerometer; clipboard-write; encrypted-media; gyroscope; autoplay;");
					videoPlayer.iframe.attr('src', url);
					
					if(videoPlayer.iframeVideo != null)
					videoPlayer.iframeVideo[0].play();
				}
		});
		
		setInterval(function() {
		    var activeElement = document.activeElement;
		    if ($(activeElement).is('iframe') && $(activeElement).hasClass('show')) {
		       $(document.activeElement).siblings('.video-icon').css('display', 'none');
		    }
		}, 100);
        
    }
    
}
isMultiple = function(){
	if($('.newVideoPlayerComponent').length > 1)return true;
	else return false;
}
findPos = function(elm){
	while (elm.attr('class') == undefined || elm.attr('class').indexOf('newVideoPlayerComponent') == -1){
		elm = elm.parent();
	}
	return Number(elm.attr('class').replace('start-anim ', '').replace('anim-right ', '').replace('anim-left ', '').replace('sectionEnter ', '').replace('section mod-com19 com19 newVideoPlayerComponent n','')[0]);
}

Intesa.videoPlayerHandler.getInstance = function () {

    if (!window.intesa) {

        window.intesa = new Object();

    }

    if (!window.intesa.video_player_handler) {

        window.intesa.video_player_handler = new Intesa.videoPlayerHandler();

    }

    return window.intesa.video_player_handler;

};